import React from 'react';
import { Card } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import AddBankCardSteps from '../../components/AddBankCardSteps/Index.js';

@connect()
export default class AddBankCardContainer extends React.Component {
  handleSaveSuccessCallback() {
    this.props.dispatch(routerRedux.replace('/merchant/business/my/base-info'));
  }

  render() {
    return (
      <Card bordered={false}>
        <AddBankCardSteps saveSuccessCallback={this.handleSaveSuccessCallback.bind(this)} />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/AddBankCard/Index.js